module.exports = __webpack_public_path__ + "static/img/bg-Introduction.362d3442.png";